// SHAH App Exports
import ShahApp from './ShahApp';

export const Dashboard = ShahApp;
